<div class="myaha-shimmer">
  <div class="myaha-profiles">
    <div
      class="vertical-row horizontal-ac"
      *ngFor="let row of [[1, 2, 3]]; let i = index; trackBy: trackByIndex"
    >
      <app-skeleton
        *ngFor="let key of row; let j = index; trackBy: trackByIndex"
        class="myaha-profile-card"
        [class.is-last-card]="j === row.length - 1"
        height=" 4.91vw"
        width="4.91vw"
        borderRadius="15vw"
      ></app-skeleton>
    </div>
  </div>

  <div class="myaha-right-content">
    <div
      class="vertical-row horizontal-ac"
      *ngFor="let row of [[1, 2, 3]]; let i = index; trackBy: trackByIndex"
    >
      <app-skeleton
        *ngFor="let key of row; let j = index; trackBy: trackByIndex"
        class="myaha-right-card"
        [class.is-last-card]="j === row.length - 1"
        height="5.93vh"
        width="13.54vw"
        borderRadius="8.44vw"
      ></app-skeleton>
    </div>
  </div>

  <div class="myaha-line">
    <app-skeleton height="0.19vh" width="90.21vw"></app-skeleton>
  </div>

  <div class="myaha-continue-watching">
    <div
      class="vertical-row horizontal-ac"
      *ngFor="let row of [[1, 2, 3, 4, 5, 6]]; let i = index; trackBy: trackByIndex"
    >
      <app-skeleton
        *ngFor="let key of row; let j = index; trackBy: trackByIndex"
        class="myaha-continue-watching-card"
        [class.is-last-card]="j === row.length - 1"
        height=" 16.67vh"
        width="16.67vw"
        borderRadius="0.63vw"
      ></app-skeleton>
    </div>
  </div>

  <div class="myaha-rentals">
    <div
      class="vertical-row horizontal-ac"
      *ngFor="let row of [[1, 2, 3, 4, 5, 6, 7]]; let i = index; trackBy: trackByIndex"
    >
      <app-skeleton
        *ngFor="let key of row; let j = index; trackBy: trackByIndex"
        class="myaha-rentals-card"
        [class.is-last-card]="j === row.length - 1"
        height="32.78vh"
        width="12.29vw"
        borderRadius="0.63vw"
      ></app-skeleton>
    </div>
  </div>
</div>
